module.exports = __webpack_public_path__ + "static/media/food2.9013e25e.jpg";